import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";
import { readAiSearchStatus, runAiSearch } from "./ai-search.server";

/** Hur många AI-sökningar den inloggade användaren har kvar idag. */
export const getAiSearchStatus = createServerFn({ method: "GET" })
  .middleware([requireSupabaseAuth])
  .handler(async ({ context }) => readAiSearchStatus(context as any));

/** Tolkar en fritextfråga och returnerar filter för annonslistan. */
export const aiSearch = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator((d: unknown) => z.object({ query: z.string().trim().min(2).max(200) }).parse(d))
  .handler(async ({ data, context }) => runAiSearch(data.query, context as any));
